export const agencyNumbers = {
  lenderHubUserAgencyNumber: 1234567,
};
